import React from 'react';
import Scroll from 'react-scroll';
import Select from 'react-select';

class FieldSelect extends React.Component {

  render() {
    const key = this.props.id;
    const field = this.props.field;
    const visible = this.props.visible;
    const editable = this.props.editable;
    const mandatory = this.props.mandatory;
    const value = this.props.value;
    const options = this.props.options.filter(option => option.visible);
    const error = this.props.error;
    const errorMessage = this.props.errorMessage;

    if(!visible || !editable) return null;

    return (
      <div className="col">
        <div className="form-group">
          <Scroll.Element name={this.props.id} />
          <label> {field.label_name} { mandatory ? <span className="required-field"/> : null} </label>
          { error ? <>&nbsp; : &nbsp; <label className="error-w">{errorMessage}</label></> : null }
          <Select 
            value={value} 
            onChange={selections => this.props.onValueChange(key, selections)}
            options={options} 
            isDisabled={!editable} 
            isSearchable={true}
            isClearable={true} 
            isMulti={false} />
        </div>
      </div>
    );
  }
}
export default FieldSelect;